import React from "react";
import { Controller } from "react-hook-form";

import { cn } from "../../utils/utils";

const OptionInput = ({ control, name, label, errors, className, options }) => {
  return (
    <div className={cn("w-[200px] flex flex-col gap-2 relative", className)}>
      <label htmlFor={name}>{label}</label>
      <Controller
        control={control}
        name={name}
        defaultValue={true}
        render={({ field: { onChange, value: active } }) => {
          return (
            <div className="flex p-1 bg-neutral-20 gap-2 h-[53px] rounded-v-md">
              {options.map((item) => (
                <button
                  tabIndex={"-1"}
                  key={item.value.toString()}
                  type="button"
                  value={item.value}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onChange(item.value);
                  }}
                  className={`flex-1 ${
                    item.value === active ? "bg-neutral-00" : ""
                  } rounded-v-md flex justify-center items-center cursor-pointer`}
                >
                  {item.title}
                </button>
              ))}
            </div>
          );
        }}
      />
      {errors?.message && <span className="text-red-500 text-sm">{errors?.message}</span>}
    </div>
  );
};

export default OptionInput;
